/* tslint:disable */
/* eslint-disable */
/**
 * Referentials API
 * API for managing referentials, including countries, civility titles, and nationalities.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReferentialDto } from './ReferentialDto';
import {
    ReferentialDtoFromJSON,
    ReferentialDtoFromJSONTyped,
    ReferentialDtoToJSON,
    ReferentialDtoToJSONTyped,
} from './ReferentialDto';
import type { ReferentialKey } from './ReferentialKey';
import {
    ReferentialKeyFromJSON,
    ReferentialKeyFromJSONTyped,
    ReferentialKeyToJSON,
    ReferentialKeyToJSONTyped,
} from './ReferentialKey';

/**
 * 
 * @export
 * @interface ReferentialWithKeyDto
 */
export interface ReferentialWithKeyDto {
    /**
     * 
     * @type {ReferentialKey}
     * @memberof ReferentialWithKeyDto
     */
    referentialKey: ReferentialKey;
    /**
     * 
     * @type {Array<ReferentialDto>}
     * @memberof ReferentialWithKeyDto
     */
    referential: Array<ReferentialDto>;
}



/**
 * Check if a given object implements the ReferentialWithKeyDto interface.
 */
export function instanceOfReferentialWithKeyDto(value: object): value is ReferentialWithKeyDto {
    if (!('referentialKey' in value) || value['referentialKey'] === undefined) return false;
    if (!('referential' in value) || value['referential'] === undefined) return false;
    return true;
}

export function ReferentialWithKeyDtoFromJSON(json: any): ReferentialWithKeyDto {
    return ReferentialWithKeyDtoFromJSONTyped(json, false);
}

export function ReferentialWithKeyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferentialWithKeyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'referentialKey': ReferentialKeyFromJSON(json['referentialKey']),
        'referential': ((json['referential'] as Array<any>).map(ReferentialDtoFromJSON)),
    };
}

export function ReferentialWithKeyDtoToJSON(json: any): ReferentialWithKeyDto {
    return ReferentialWithKeyDtoToJSONTyped(json, false);
}

export function ReferentialWithKeyDtoToJSONTyped(value?: ReferentialWithKeyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referentialKey': ReferentialKeyToJSON(value['referentialKey']),
        'referential': ((value['referential'] as Array<any>).map(ReferentialDtoToJSON)),
    };
}

